import axiosInstance from '../../../axiosInstance';
import apiEndpoints from '../../../api';
import { selectedSocietyStorer } from '../../../../utils/webStorer';

export const getSocietyDashboardReq = (action) => {
    const societyId = action?.data?.societyId;
    const url = apiEndpoints.GET_SOCIETY_DASHBOARD_API.replace(':societyId', societyId);
    return axiosInstance.get(url)
        .then(response => response)
        .catch((errors) => errors);
};

export const getOperationsDashboardReq = (action) => {
    // Callers:
    //   - Super admin SocietyController page passes `society_id: <id> | 'all'`
    //     explicitly (dropdown value → 'all' for the cross-society aggregate).
    //   - Society admin SocietyPortal page passes nothing — we auto-scope to
    //     their active society (from the storer) so the server-side
    //     societyContext middleware always has something to resolve.
    // We also send X-Society-Id as a redundancy header — the server ignores
    // it for super admin callers (they get their own query-driven scoping).
    const passedSocietyId = action?.data?.society_id;
    const activeSocietyId = selectedSocietyStorer.getSocietyId();
    const params = {};
    if (passedSocietyId != null && passedSocietyId !== '') {
        params.society_id = passedSocietyId;
    } else if (activeSocietyId) {
        params.society_id = activeSocietyId;
    }

    const headers = {};
    if (activeSocietyId) headers['X-Society-Id'] = activeSocietyId;

    return axiosInstance.get(apiEndpoints.GET_OPERATIONS_DASHBOARD_API, { params, headers })
        .then(response => response)
        .catch((errors) => errors);
};
